
import { trackButtonClick } from '../../../analytics';

export default function Hero() {
  return (
    <>
      {/* Black Friday Banner - Desktop */}
      <section className="bg-gray-900 text-white py-4 hidden md:block">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-center gap-8">
            <h5 className="text-xl font-semibold">Christmas Sale!</h5>
          </div>
        </div>
      </section>

      {/* Black Friday Banner - Mobile */}
      <section className="bg-gray-900 text-white py-6 md:hidden">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-2xl font-bold text-center">Christmas Sale!</h2>
        </div>
      </section>

      {/* Main Hero Section */}
      <section className="bg-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 hidden md:block">
              Master AI Filmmaking In 2 Days
            </h2>
            <h3 className="text-3xl font-bold text-gray-900 mb-6 md:hidden">
              Master AI Filmmaking In 2 Days
            </h3>
            <p className="text-xl font-semibold text-gray-900 mb-12">
              <strong className="bg-yellow-300 px-2 py-1">Social Media Content, Profitable ads, Short films, and more! No Subscriptions required.</strong>
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            {/* Image */}
            <div className="w-full">
              <img
                src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/58e9dbb33d21a2403fa8930cfcdd02a8.jpeg"
                alt="AI Creator Course"
                className="w-full h-auto object-cover rounded-lg"
              />
            </div>

            {/* Content - Desktop */}
            <div className="hidden md:block">
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                <strong>The AI Creator Course</strong> is for anyone who wants to master AI tools <em>(the easy way)</em>. Learn how to go viral, grow your audience, and scale a business with modern AI.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                <strong>Christmas Sale:</strong> Right now you can get the AI Creator Course for a one time payment of $98 (68% off 😱)
              </p>
              <a
                href="/checkout"
                className="inline-block bg-green-600 text-white px-10 py-5 rounded-full text-xl font-semibold hover:bg-green-700 transition-all whitespace-nowrap cursor-pointer"
                onClick={() => trackButtonClick('get_lifetime_access', 'hero_desktop')}
              >
                Get Lifetime Access Today!
              </a>
            </div>

            {/* Content - Mobile */}
            <div className="md:hidden text-center">
              <p className="text-base text-gray-700 mb-6 leading-relaxed">
                <strong>The AI Creator Course</strong> is for anyone who wants to master AI tools <em>(the easy way)</em>. Learn how to go viral, grow your audience, and scale a business with modern AI.
              </p>
              <a
                href="/checkout"
                className="inline-block bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-green-700 transition-all whitespace-nowrap cursor-pointer mb-6"
                onClick={() => trackButtonClick('get_lifetime_access', 'hero_mobile')}
              >
                Get Lifetime Access Today!
              </a>
              <p className="text-base text-gray-700 leading-relaxed">
                <strong>Christmas Sale:</strong> Right now you can get the AI Creator Course for a one time payment of $98 (68% off 😱)
              </p>
            </div>
          </div>

          {/* No Experience Needed Banner */}
          <div className="mt-16 max-w-4xl mx-auto">
            <div className="bg-gray-900 text-white p-8 rounded-lg text-center">
              <h4 className="text-3xl md:text-4xl font-bold mb-3 text-cyan-400">
                <span>No Experience Needed!</span>
              </h4>
              <h4 className="text-3xl md:text-4xl font-bold leading-tight">Here's What You Will Learn In 2 Days:</h4>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
